import React from "react";

import Select, { GroupBase, Props as SelectProps } from "react-select";

import customComponents from "./CustomComponents";
import useGetDropdownStyles from "./hooks/useGetDropdownStyles";

export type Props<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = SelectProps<Option, IsMulti, Group> & {
  size?: "small" | "medium";
  error?: boolean;
  dataNoTranslate?: boolean;
};

export default function Dropdown<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
  const {
    dataNoTranslate,
    styles: ignoreStyles,
    size = "small",
    error = false,
    ...otherProps
  } = props;

  const styles = useGetDropdownStyles<Option, IsMulti, Group>({ size, error });

  return (
    <Select
      components={dataNoTranslate ? customComponents : undefined}
      styles={styles}
      {...otherProps}
    />
  );
}
